import { QueryClient } from "@tanstack/react-query";

// Admin queries are mostly back-office reads — refresh on focus is more
// valuable than the consumer app's "don't refetch" stance, but we keep the
// retry off so 401/403 surfaces immediately to the AuthGuard instead of
// being smeared across N silent retries.
export const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      retry: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 30,
    },
  },
});
